import { AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsNameExtraInfo } from 'common/customers/services/types/RsNameExtraInfo';
import { NameExtraAdd } from 'common/customers/services/types/NameExtraAdd';
import { NameExtraUpdate } from 'common/customers/services/types/NameExtraUpdate';
import { RsNameExtra } from 'common/customers/services/types/RsNameExtra';

export function nameExtraFromGetToUpdateParams(params: RsNameExtraInfo): NameExtraUpdate {
    return {
        name: params.name,
        nameLatin: params.nameLatin,
        orderNo: params.orderNo,
        sex: params.sex
    };
}

export type ICustomerNameExtraDataProvider = IDataProviderV2<RsNameExtra, RsNameExtraInfo, NameExtraAdd, NameExtraUpdate>;

export class CustomerNameExtraDataProvider
    extends AbstractDataProviderV2<RsNameExtra, RsNameExtraInfo, NameExtraAdd, NameExtraUpdate>
    implements ICustomerNameExtraDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/name-extras');
    }

    public patch(): Promise<any> {
        return Promise.reject('method "Patch" is not supported, use "customPatch"');
    }
}
